<template>
  <div class="DialogProfileUserAttach__Component">
    <form @submit.prevent="save" novalidate="true">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">שיוך משתמש קיים</p>
          <button type="button" class="delete" @click="$emit('close')" />
        </header>
        <section class="modal-card-body">
          <div class="DialogProfileUserAttach__Component__Loading">
            <div class="field">
              <b-field label="חפש משתמש לפי שם/אימייל/מזהה">
              <b-input
                type="text"
                v-model="searchTerm"
                placeholder="חפש משתמש"
                @input="searchUsers(searchTerm)"
              />
              </b-field>
              <b-table
                :loading="isLoading"
                :data="searchResults"
                :columns="[{
                  label: 'שם משתמש',
                  field: 'FullName',
                }, {
                  label: 'אימייל',
                  field: 'Email',
                }, {
                  label: 'מזהה',
                  field: 'Id',
                }]"
                :selected.sync="selectedUser"
                @click="onUserClick"
                focusable
              />
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button
            native-type="submit"
            :loading="isLoading"
            label="שמור"
            type="is-primary"
          />
          <b-button
            :disabled="isLoading"
            label="סגור"
            @click="$emit('close')"
          />
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import { ToastProgrammatic as Toast } from "buefy";
import ProfileService from "@/services/ProfileService";
import store from "../store";

export default {
  name: "DialogProfileUserAttach",
  props: ["onSuccess"],
  data() {
    return {
      isLoading: false,
      selectedUser: null,
      showError: false,
      searchTerm: "",
      searchResults: [],
      debounceTimer: null,
    };
  },
  computed: {
    profileId() {
      return store.state.profile.Id;
    },
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
  methods: {
    searchUsers(searchTerm) {
      this.isLoading = true;
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      if (!searchTerm || searchTerm.length < 3) {
        this.searchResults = [];
        this.isLoading = false;
        return;
      }

      this.debounceTimer = setTimeout(() => {
        this.isLoading = true;
        ProfileService.searchUsers(searchTerm).then((r) => {
          this.searchResults = r.data;
        })
        .catch(() => {
          this.searchResults = [];
          this.isLoading = false;
          Toast.open({
            type: "is-danger",
            message: "אירעה שגיאה בחיפוש!",
            duration: 8000,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
      }, 300);
    },
    onUserClick(user) {
      this.selectedUser = user;
    },
    save() {
      if (!this.selectedUser) {
        this.showError = true;
        return;
      }
      this.isLoading = true;

      ProfileService.attachUser(this.profileId, this.selectedUser.Id)
        .then(() => {
          this.$emit("close");
          if (this.onSuccess) {
            this.onSuccess();
          }
          Toast.open({
            type: "is-success",
            message: "המשתמש שויך בהצלחה!",
            duration: 4000,
          });
        })
        .catch((err) => {
          let message = "לא ניתן לבצע את הפעולה!";
          if (err.response?.status === 400) {
            const serverMessage = err.response?.data?.ModelState?.[""][0];
            if (serverMessage === "User is already associated with this profile") {
              message = "המשתמש כבר משויך לפרופיל זה";
            } else {
              message = serverMessage || message;
            }
          }
          Toast.open({
            type: "is-danger",
            message,
            duration: 8000,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.DialogProfileUserAttach__Component {
  .modal-card {
    height: 80vh;
  }
  .DialogProfileUserAttach__Component__Loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .field {
    margin-top: 40px;
    width: 100%;
  }
}
.error {
  color: red;
  font-size: 15px;
}
</style>
